import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=445606b2&scoped=true"
import script from "./language-switcher.vue?vue&type=script&lang=js"
export * from "./language-switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445606b2",
  null
  
)

export default component.exports